export const SMALL_COLOR_SIZE = 5
export const DEFAULT_COLOR_SIZE = 10
